const events = ['onTaskCreate']
const operators = ['>', '<', '>=', '<=', '==', '!=']
const logicalOperators = ['AND', 'OR']
const conditions = ['IF', 'ELSE IF', 'ELSE']
const fns = ['approve_all', 'reject_one', 'vote']

const examples = `# Allowed Triggers: ${events.join(', ')}
# Allowed Operators: ${operators.join(', ')}
# Allowed Blocks: ${conditions.join(', ')}
# Allowed Logical Operators: ${logicalOperators.join(', ')}
# Allowed Functions: ${fns.join(', ')}


#1 Example
IF amount < 100000 AND project > "Hub-02"
THEN
  approve_all("ok")

ELSE
  reject_one("amount", "Too high")
  vote("Send Back")


#2 Multi Level Condition
IF amount > 10000
THEN
  approve_all("high")

ELSE IF project == "hub-02"
THEN
  approve_all("hub")

ELSE
  reject_one("amount", "invalid")   
`

const placeholder = `IF amount > 10000
THEN
  approve_all("high")

ELSE IF project == "hub-02"
THEN
  approve_all("hub")

ELSE
  reject_one("amount", "invalid")
`

module.exports = { examples, placeholder, events, operators, logicalOperators, conditions }
